/*******************************************************************************
Close Side Navigation
Closes the offscreen navigation menu on the right side of the page.
*******************************************************************************/

import clearSectionSearch from './search/clear';

// Closes the side navigation menu
export default function closeSideNav(e) {

    // Prevents clicks on random elements within the site wrapper from doing anything
    e.preventDefault();

    // The side nav container
    const $sideNav = $('.side-nav');

    // Remove the class on the side nav container that signals that side nav is currently open
    $sideNav.removeClass('is-open');

    // Close any open sub sections
    $('.side-nav__group').removeClass('is-open');

    // Remove the class on the site wrapper container that signals that side nav is currently open
    $('.site-wrapper').removeClass('side-nav-is-open');

    // Remove the overflow:hidden style from the body so scrolling is possible
    $('body').removeClass('hide-overflow');

    // Clear the section search
    clearSectionSearch();
}
